import { DIRECTION_MAP, type GraphQLSortOrder, type SortOrder, type SortOrderValue } from "./types"

export const transformSortArrayToGraphQLSortOrder = (sortOrder: SortOrder[], defaultFilter?: GraphQLSortOrder): GraphQLSortOrder | null => {
  if (!sortOrder && !defaultFilter) {
    return null
  }

  if ((!sortOrder || sortOrder.length === 0) && defaultFilter) {
    return defaultFilter
  }

  return sortOrder.reduce((result, sort) => {
    return {
      ...result,
      [sort.columnId]: DIRECTION_MAP[sort.direction] as SortOrderValue,
    }
  }, {})
}
